import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { PaymentLinkDetailsList, PaymentLinkDetailsListItem } from './PaymentLinkDetails.styles';

const PaymentLinkDetails = ({ amount, id, reference, status, expiresAt, url, description }) => (
  <PaymentLinkDetailsList>
    <PaymentLinkDetailsListItem>
      <strong>
        <FormattedMessage id="paymentsSummary.amount" />
        {': '}
      </strong>
      <FormattedCurrency currency={amount.currency} amount={parseFloat((amount.value / 100).toFixed(2))} />
    </PaymentLinkDetailsListItem>
    <PaymentLinkDetailsListItem>
      <strong>
        <FormattedMessage id="paymentLink.id" />
        {': '}
      </strong>
      <span>{id}</span>
    </PaymentLinkDetailsListItem>
    <PaymentLinkDetailsListItem>
      <strong>
        <FormattedMessage id="paymentLink.reference" />
        {': '}
      </strong>
      <span>{reference}</span>
    </PaymentLinkDetailsListItem>
    <PaymentLinkDetailsListItem>
      <strong>
        <FormattedMessage id="paymentsSummary.status" />
        {': '}
      </strong>
      <span>{status}</span>
    </PaymentLinkDetailsListItem>
    <PaymentLinkDetailsListItem>
      <strong>
        <FormattedMessage id="paymentLink.expiresAt" />
        {': '}
      </strong>
      <span>{moment(expiresAt).format('DD/MM/YY HH:mm')}</span>
    </PaymentLinkDetailsListItem>
    <PaymentLinkDetailsListItem>
      <strong>
        <FormattedMessage id="paymentLink.reason" />
        {': '}
      </strong>
      <span>{description}</span>
    </PaymentLinkDetailsListItem>
    <PaymentLinkDetailsListItem>
      <strong>
        <FormattedMessage id="paymentLink.paymentLink" />
        {': '}
      </strong>
      <a target="_blank" href={url} rel="noreferrer">
        {url}
      </a>
    </PaymentLinkDetailsListItem>
  </PaymentLinkDetailsList>
);

PaymentLinkDetails.propTypes = {
  amount: PropTypes.shape({
    currency: PropTypes.string,
    value: PropTypes.number
  }),
  id: PropTypes.string,
  reference: PropTypes.string,
  status: PropTypes.string,
  expiresAt: PropTypes.string,
  url: PropTypes.string,
  description: PropTypes.string
};

export default PaymentLinkDetails;
